import type {
  ParamsGetInputsProductsAll,
  ProductSortableColumn,
} from "@CommonApi/inputs/products/all";

type CurrentProductsSort = Pick<ParamsGetInputsProductsAll, "sortBy" | "sortDirection">;

export const getNextProductsSort = (
  currentSort: CurrentProductsSort,
  sortKey: ProductSortableColumn,
): CurrentProductsSort => {
  if (currentSort.sortBy !== sortKey || !currentSort.sortDirection) {
    return {
      sortBy: sortKey,
      sortDirection: "asc",
    };
  }

  if (currentSort.sortDirection === "asc") {
    return {
      sortBy: sortKey,
      sortDirection: "desc",
    };
  }

  return {
    sortBy: undefined,
    sortDirection: undefined,
  };
};
